import React, { useEffect } from 'react';
import { LoggerModule } from '@vlinder-web/logger-module-react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let roeCompanySetupPageMachine: any;

const MODULE_NAME = 'machines.roeCompanySetup';
const log: any = LoggerModule?.getInstance();

export const useSMroeCompanySetupPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  roeCompanySetupPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(roeCompanySetupPageMachine);

  return {
    roeCompanySetupPageMachine,
    roeCompanySetupPageState: state,
    roeCompanySetupPageSend: send,
  };
};
